// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListedPicture_main__h-zi7 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: default;
}

.ComponentListedPicture_container__kNFFo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    height: 100%;
}

.ComponentListedPicture_container_header__YbIH4 {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 30px;
    color: #101417;
}

.ComponentListedPicture_container_action_list__BuoYy {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
}

.ComponentListedPicture_action_list_left__9Uny3 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.ComponentListedPicture_action_list_right__\\+Pc2y {

}

.ComponentListedPicture_container_content__AUrTr,
.ComponentListedPicture_container_detail_list_box__FAeAM,
.ComponentListedPicture_container_component_content__wJnE3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: calc(100% - 50px);
}

.ComponentListedPicture_container_detail_list_box__FAeAM {
    align-items: flex-start;
}

.ComponentListedPicture_container_detail_list_main__0lWPQ {
    width: 100%;
    height: 100%;
}

.ComponentListedPicture_container_content_left__MYe00,
.ComponentListedPicture_container_content_right__XxXUN {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 48%;
    height: 100%;
    border-radius: 12px;
}

.ComponentListedPicture_container_detail_list__tJsxk {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedPicture_container_detail_list__tJsxk::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedPicture_container_detail_list__tJsxk::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedPicture_container_detail_list__tJsxk::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedPicture_left_components_title__zMMBw {
    font-size: 30px;
    font-weight: bold;
}

.ComponentListedPicture_left_components__4vCwA {
    width: 100%;
    height: calc(100% - 50px);
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedPicture_left_components__4vCwA::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedPicture_left_components__4vCwA::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedPicture_left_components__4vCwA::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedPicture_more_img__ObUW\\+ {
    width: 12px;
    height: 13px;
}

.ComponentListedPicture_shopping_model_item_box__K8iik,
.ComponentListedPicture_components_add__G-krb {
    width: 100%;
    padding: 10px;
    background-color: #ffffff;
    margin-bottom: 15px;
    cursor: pointer;
    border-radius: 12px;
    border: 2px solid #a6a6a6;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}

.ComponentListedPicture_shopping_model_item_box__K8iik:hover {
    border: 2px solid #74BDC6;
}

.ComponentListedPicture_components_add__G-krb {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    border: 2px solid #fff;
}

.ComponentListedPicture_components_add__G-krb:hover {
    background-color: #f2f8f9;
}

.ComponentListedPicture_shopping_model_item_box_select__JLipF {
    border: 2px solid #74BDC6;
}

.ComponentListedPicture_shopping_model_item__ngT\\+n {
    display: flex;
    justify-content: space-between;
    width: 100%;
    /* height: 93px; */
    padding: 10px 7px;
    border-radius: 12px;
}

.ComponentListedPicture_shopping_model_img_box__C7f-W {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    min-width: 51px;
    height: 51px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #FFF;
}

.ComponentListedPicture_shopping_model_img__3yeFS {
    width: 38px;
    height: 38px;
}

.ComponentListedPicture_shopping_model_text_box__gFglO {
    width: calc(100% - 51px - 115px);
    padding: 0 5px;
}

.ComponentListedPicture_shopping_model_text_box_unowned__83804 {
    padding: 0 10px 0 14px;
}

.ComponentListedPicture_shopping_model_text_title__ULVP0 {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ComponentListedPicture_shopping_model_text_info__9luvO {
    display: -webkit-box;        /* 创建一个弹性盒子 */
    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */
    -webkit-line-clamp: 3;       /* 限制显示两行 */
    overflow: hidden;            /* 隐藏超出内容 */
    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */
    color: #414648;
    font-size: 12px;
    line-height: 20px;
}

.ComponentListedPicture_shopping_model_butn__0nOQ7 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    border-radius: 6px;
    font-size: 11px;
}

.ComponentListedPicture_shopping_model_owned__dW7Az {
    width: 83px;
    min-width: 83px;
    color: #74bdc6;
    background-color: #e4f0f2;
    border: 1px solid #74bdc6;
    border-bottom-width: 2px;
}

.ComponentListedPicture_shopping_model_purchase__uLRwR {
    width: 128px;
    min-width: 128px;
    color: #EABC4E;
    background-color: #FFF;
    border: 1px solid #D9D9D9;
    border-bottom-width: 2px;
}

.ComponentListedPicture_model_status_img__l5D8P {
    margin-right: 5px;
}

.ComponentListedPicture_right_header_img_box__TWm9W {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 118px;
}

.ComponentListedPicture_right_header_img__a-AMi {
    width: 100px;
    height: 100px;
}

.ComponentListedPicture_right_header_text_box__E2ID- {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.ComponentListedPicture_right_header_text__AgNno {
    margin-bottom: 10px;
}

.ComponentListedPicture_introduce_box__dCgm1,
.ComponentListedPicture_example_box__GTTqd {
    width: 100%;
    padding: 10px 0;
}

.ComponentListedPicture_introduce_title__wvmjc,
.ComponentListedPicture_example_title__vzkFw {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ComponentListedPicture_introduce_text__sbSi7,
.ComponentListedPicture_example_text__amuSx {
    width: 100%;
    padding: 10px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 12px;
    color: #414648;
}

.ComponentListedPicture_action_list__1rpmM {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 115px;
}

.ComponentListedPicture_left_components_add__Y1W6E {
    width: 100%;
    height: 50px;
    font-size: 30px;
}

.ComponentListedPicture_card_box_add__Io5Jv,
.ComponentListedPicture_card_box__MipxR {
    position: relative;
    width: 265px;
    margin: 0 15px 15px 0;
    min-height: 250px;
    max-height: 300px;
}

.ComponentListedPicture_card_box_add__Io5Jv {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    border-radius: 6px;
    cursor: pointer;
}

.ComponentListedPicture_card_box_select__M3cuo .ComponentListedPicture_card_box_cover__GrNim {
    display: block;
}

.ComponentListedPicture_card_box_cover__GrNim {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 265px;
    height: 300px;
    z-index: 11;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.ComponentListedPicture_select_img_box__zCnKe {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 32px;
    height: 32px;
    background-color: #fff;
    border-radius: 32px;
}

.ComponentListedPicture_card_box_cover_select__uAD7h,
.ComponentListedPicture_card_box_cover_unselect__nHdGn {
    -webkit-user-select: none;
            user-select: none;
}

.ComponentListedPicture_detail_card__alrp3 .ant-card-meta-detail .ant-card-meta-title {
    font-size: 12px;
    white-space: wrap;
}

.ComponentListedPicture_detail_card__alrp3 .ant-card-body {
    padding: 5px !important;
}

.ComponentListedPicture_card_info_box__szhbX {

}

.ComponentListedPicture_card_img__DttOQ {
    width: 265px;
    height: 200px;
}

.ComponentListedPicture_card_action_box__7akDs {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
}

.ComponentListedPicture_card_action_img_box__7PZp5 {
    width: 25px;
    height: 25px;
    margin-left: 10px;
}

.ComponentListedPicture_card_action_img_box__7PZp5:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.ComponentListedPicture_card_action_img__oTtIb {
    width: 25px;
    height: 25px;
}

.ComponentListedPicture_card_label_box__6hDBX {
    width: 100px;
    height: 25px;
}

.ComponentListedPicture_card_tag__Kn1H9,
.ComponentListedPicture_card_untag__aTA2j {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #6fda72;
    border-radius: 6px;
}

.ComponentListedPicture_card_untag__aTA2j {
    background-color: #66b6f1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListedPicture/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;;;IAGI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,yEAA2C,UAAU;IACjD,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,+EAAiD,WAAW;IACxD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,mEAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,yEAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB,SAAS,aAAa;IAC1C,4BAA4B,EAAE,oBAAoB;IAClD,qBAAqB,QAAQ,WAAW;IACxC,gBAAgB,aAAa,WAAW;IACxC,uBAAuB,MAAM,iBAAiB;IAC9C,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;AAEA;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".main {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    cursor: default;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 80%;\n    height: 100%;\n}\n\n.container_header {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: 50px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 30px;\n    color: #101417;\n}\n\n.container_action_list {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 50px;\n}\n\n.action_list_left {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.action_list_right {\n\n}\n\n.container_content,\n.container_detail_list_box,\n.container_component_content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: calc(100% - 50px);\n}\n\n.container_detail_list_box {\n    align-items: flex-start;\n}\n\n.container_detail_list_main {\n    width: 100%;\n    height: 100%;\n}\n\n.container_content_left,\n.container_content_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 48%;\n    height: 100%;\n    border-radius: 12px;\n}\n\n.container_detail_list {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    max-height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container_detail_list::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.container_detail_list::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container_detail_list::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.left_components_title {\n    font-size: 30px;\n    font-weight: bold;\n}\n\n.left_components {\n    width: 100%;\n    height: calc(100% - 50px);\n    padding: 0 20px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.left_components::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.left_components::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.left_components::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.more_img {\n    width: 12px;\n    height: 13px;\n}\n\n.shopping_model_item_box,\n.components_add {\n    width: 100%;\n    padding: 10px;\n    background-color: #ffffff;\n    margin-bottom: 15px;\n    cursor: pointer;\n    border-radius: 12px;\n    border: 2px solid #a6a6a6;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);\n}\n\n.shopping_model_item_box:hover {\n    border: 2px solid #74BDC6;\n}\n\n.components_add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    border: 2px solid #fff;\n}\n\n.components_add:hover {\n    background-color: #f2f8f9;\n}\n\n.shopping_model_item_box_select {\n    border: 2px solid #74BDC6;\n}\n\n.shopping_model_item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    /* height: 93px; */\n    padding: 10px 7px;\n    border-radius: 12px;\n}\n\n.shopping_model_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 51px;\n    min-width: 51px;\n    height: 51px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #FFF;\n}\n\n.shopping_model_img {\n    width: 38px;\n    height: 38px;\n}\n\n.shopping_model_text_box {\n    width: calc(100% - 51px - 115px);\n    padding: 0 5px;\n}\n\n.shopping_model_text_box_unowned {\n    padding: 0 10px 0 14px;\n}\n\n.shopping_model_text_title {\n    width: 100%;\n    height: 28px;\n    line-height: 28px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.shopping_model_text_info {\n    display: -webkit-box;        /* 创建一个弹性盒子 */\n    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */\n    -webkit-line-clamp: 3;       /* 限制显示两行 */\n    overflow: hidden;            /* 隐藏超出内容 */\n    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */\n    color: #414648;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.shopping_model_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 28px;\n    border-radius: 6px;\n    font-size: 11px;\n}\n\n.shopping_model_owned {\n    width: 83px;\n    min-width: 83px;\n    color: #74bdc6;\n    background-color: #e4f0f2;\n    border: 1px solid #74bdc6;\n    border-bottom-width: 2px;\n}\n\n.shopping_model_purchase {\n    width: 128px;\n    min-width: 128px;\n    color: #EABC4E;\n    background-color: #FFF;\n    border: 1px solid #D9D9D9;\n    border-bottom-width: 2px;\n}\n\n.model_status_img {\n    margin-right: 5px;\n}\n\n.right_header_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 118px;\n    height: 118px;\n}\n\n.right_header_img {\n    width: 100px;\n    height: 100px;\n}\n\n.right_header_text_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_header_text {\n    margin-bottom: 10px;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    padding: 10px 0;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 12px;\n    color: #414648;\n}\n\n.action_list {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    width: 115px;\n}\n\n.left_components_add {\n    width: 100%;\n    height: 50px;\n    font-size: 30px;\n}\n\n.card_box_add,\n.card_box {\n    position: relative;\n    width: 265px;\n    margin: 0 15px 15px 0;\n    min-height: 250px;\n    max-height: 300px;\n}\n\n.card_box_add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #ffffff;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.card_box_select .card_box_cover {\n    display: block;\n}\n\n.card_box_cover {\n    display: none;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 265px;\n    height: 300px;\n    z-index: 11;\n    border-radius: 6px;\n    background-color: rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n}\n\n.select_img_box {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    width: 32px;\n    height: 32px;\n    background-color: #fff;\n    border-radius: 32px;\n}\n\n.card_box_cover_select,\n.card_box_cover_unselect {\n    user-select: none;\n}\n\n.detail_card :global(.ant-card-meta-detail .ant-card-meta-title) {\n    font-size: 12px;\n    white-space: wrap;\n}\n\n.detail_card :global(.ant-card-body) {\n    padding: 5px !important;\n}\n\n.card_info_box {\n\n}\n\n.card_img {\n    width: 265px;\n    height: 200px;\n}\n\n.card_action_box {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 10px;\n}\n\n.card_action_img_box {\n    width: 25px;\n    height: 25px;\n    margin-left: 10px;\n}\n\n.card_action_img_box:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.card_action_img {\n    width: 25px;\n    height: 25px;\n}\n\n.card_label_box {\n    width: 100px;\n    height: 25px;\n}\n\n.card_tag,\n.card_untag {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    background-color: #6fda72;\n    border-radius: 6px;\n}\n\n.card_untag {\n    background-color: #66b6f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ComponentListedPicture_main__h-zi7`,
	"container": `ComponentListedPicture_container__kNFFo`,
	"container_header": `ComponentListedPicture_container_header__YbIH4`,
	"container_action_list": `ComponentListedPicture_container_action_list__BuoYy`,
	"action_list_left": `ComponentListedPicture_action_list_left__9Uny3`,
	"action_list_right": `ComponentListedPicture_action_list_right__+Pc2y`,
	"container_content": `ComponentListedPicture_container_content__AUrTr`,
	"container_detail_list_box": `ComponentListedPicture_container_detail_list_box__FAeAM`,
	"container_component_content": `ComponentListedPicture_container_component_content__wJnE3`,
	"container_detail_list_main": `ComponentListedPicture_container_detail_list_main__0lWPQ`,
	"container_content_left": `ComponentListedPicture_container_content_left__MYe00`,
	"container_content_right": `ComponentListedPicture_container_content_right__XxXUN`,
	"container_detail_list": `ComponentListedPicture_container_detail_list__tJsxk`,
	"left_components_title": `ComponentListedPicture_left_components_title__zMMBw`,
	"left_components": `ComponentListedPicture_left_components__4vCwA`,
	"more_img": `ComponentListedPicture_more_img__ObUW+`,
	"shopping_model_item_box": `ComponentListedPicture_shopping_model_item_box__K8iik`,
	"components_add": `ComponentListedPicture_components_add__G-krb`,
	"shopping_model_item_box_select": `ComponentListedPicture_shopping_model_item_box_select__JLipF`,
	"shopping_model_item": `ComponentListedPicture_shopping_model_item__ngT+n`,
	"shopping_model_img_box": `ComponentListedPicture_shopping_model_img_box__C7f-W`,
	"shopping_model_img": `ComponentListedPicture_shopping_model_img__3yeFS`,
	"shopping_model_text_box": `ComponentListedPicture_shopping_model_text_box__gFglO`,
	"shopping_model_text_box_unowned": `ComponentListedPicture_shopping_model_text_box_unowned__83804`,
	"shopping_model_text_title": `ComponentListedPicture_shopping_model_text_title__ULVP0`,
	"shopping_model_text_info": `ComponentListedPicture_shopping_model_text_info__9luvO`,
	"shopping_model_butn": `ComponentListedPicture_shopping_model_butn__0nOQ7`,
	"shopping_model_owned": `ComponentListedPicture_shopping_model_owned__dW7Az`,
	"shopping_model_purchase": `ComponentListedPicture_shopping_model_purchase__uLRwR`,
	"model_status_img": `ComponentListedPicture_model_status_img__l5D8P`,
	"right_header_img_box": `ComponentListedPicture_right_header_img_box__TWm9W`,
	"right_header_img": `ComponentListedPicture_right_header_img__a-AMi`,
	"right_header_text_box": `ComponentListedPicture_right_header_text_box__E2ID-`,
	"right_header_text": `ComponentListedPicture_right_header_text__AgNno`,
	"introduce_box": `ComponentListedPicture_introduce_box__dCgm1`,
	"example_box": `ComponentListedPicture_example_box__GTTqd`,
	"introduce_title": `ComponentListedPicture_introduce_title__wvmjc`,
	"example_title": `ComponentListedPicture_example_title__vzkFw`,
	"introduce_text": `ComponentListedPicture_introduce_text__sbSi7`,
	"example_text": `ComponentListedPicture_example_text__amuSx`,
	"action_list": `ComponentListedPicture_action_list__1rpmM`,
	"left_components_add": `ComponentListedPicture_left_components_add__Y1W6E`,
	"card_box_add": `ComponentListedPicture_card_box_add__Io5Jv`,
	"card_box": `ComponentListedPicture_card_box__MipxR`,
	"card_box_select": `ComponentListedPicture_card_box_select__M3cuo`,
	"card_box_cover": `ComponentListedPicture_card_box_cover__GrNim`,
	"select_img_box": `ComponentListedPicture_select_img_box__zCnKe`,
	"card_box_cover_select": `ComponentListedPicture_card_box_cover_select__uAD7h`,
	"card_box_cover_unselect": `ComponentListedPicture_card_box_cover_unselect__nHdGn`,
	"detail_card": `ComponentListedPicture_detail_card__alrp3`,
	"card_info_box": `ComponentListedPicture_card_info_box__szhbX`,
	"card_img": `ComponentListedPicture_card_img__DttOQ`,
	"card_action_box": `ComponentListedPicture_card_action_box__7akDs`,
	"card_action_img_box": `ComponentListedPicture_card_action_img_box__7PZp5`,
	"card_action_img": `ComponentListedPicture_card_action_img__oTtIb`,
	"card_label_box": `ComponentListedPicture_card_label_box__6hDBX`,
	"card_tag": `ComponentListedPicture_card_tag__Kn1H9`,
	"card_untag": `ComponentListedPicture_card_untag__aTA2j`
};
export default ___CSS_LOADER_EXPORT___;
